import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { getLineBreakersQuantity, getLengthWithoutLineBreakers, CustomComponent } from '@cakeiteasy/web-utils';
import { Subject } from 'rxjs';
import { debounceTime, filter } from "rxjs/operators";

@Component({
  standalone: false,
  selector: 'ui-cake-build-greeting-card',
  templateUrl: './ui-cake-build-greeting-card.component.html',
})
export class UiCakeBuildGreetingCardComponent extends CustomComponent implements OnInit {
  @Input() public text: string = '';
  @Input() public cardPrice: number = 0;
  @Input() public maxLength: number = 0;
  @Input() public currency: string = 'kr';
  @Output() public onChecked = new EventEmitter<boolean>();
  @Output() public onTextChange = new EventEmitter<string>();

  public isGreetingText: boolean;
  public textLength: number = 0;
  public textChanged$ = new Subject<string>();

  ngOnInit() {
    this.isGreetingText = !!this.text;
    this.onChecked.emit(this.isGreetingText);
    this._subscribe();
  }

  private _subscribe() {
    this.addSubscriber(this.textChanged$
      .pipe(
        filter((text) => text !== undefined),
        debounceTime(50)
      )
      .subscribe((text) => {
        this.textLength = getLengthWithoutLineBreakers(text);
        const endPosition = this.maxLength + getLineBreakersQuantity(text);
        this.text = text.substr(0, endPosition);
        this.onTextChange.emit(this.text);
      }));
  }
}
